module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/art/gallery/art-gallery-13-dfd557a8b470fa76ea4f52398b2a1a16.jpg";